import {getApiMetadataWithoutToken} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {MemexStatus} from './contracts'

export type MemexUpdateStatusBody = {
  id: number
  body: string
  startDate: string | null
  targetDate: string | null
  statusId: string | null
}

export async function apiUpdateMemexStatus(body: MemexUpdateStatusBody): Promise<MemexStatus> {
  const apiData = getApiMetadataWithoutToken('memex-status-update-api-data')
  const {data} = await fetchJSONWith<MemexStatus>(apiData.url, {method: 'PUT', body})
  return data
}
